import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import Mission from './section-components/mission';
import AboutUs from './section-components/about-us';
import ServiceTwo from './section-components/service-two';
import Team from './section-components/team';
import Footer from './global-components/footer';
import Agents from './section-components/agents';
import Careers from './section-components/careers';
import { Helmet } from 'react-helmet';
import AboutCardSection from './new-components/aboutCardSection';
import AboutLsContent from './new-components/aboutlastContent';
import AboutHeader from './global-components/About-Header';
import Testimonial from './section-components/testimonial';
import Faqs from './section-components/faq';
import BlogContact from '../utils/blogContact';

const About = () => {
    return <div>
        <Helmet>
            <title>About Us |  Dubai Off-Plan & Luxury Property Experts</title>
            <meta name="description" content="Your trusted partner for off-plan properties, luxury homes,& real estate investments in Dubai. Learn more about our mission, team, and services." />
        </Helmet>
        <Navbar />
        {/* <PageHeader headertitle="About Us" /> */}
        <AboutHeader headertitle="About Us"/>
        <Mission />
        {/* <AboutCardSection /> */}
        <Testimonial />
        <Faqs/>

       <div style={{paddingBottom : '35px'}}>
       <BlogContact />
       </div>
       
        <Footer />
    </div>
}

export default About

